import { render, staticRenderFns } from "./subdivisionsEditView.vue?vue&type=template&id=2ca635d4&scoped=true"
import script from "./subdivisionsEditView.vue?vue&type=script&lang=js"
export * from "./subdivisionsEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca635d4",
  null
  
)

export default component.exports